import { css } from '@adornis/chemistry/directives/css.js';
import '@adornis/chemistry/elements/components/x-flex.js';
import '@adornis/chemistry/elements/components/x-grid.js';
import '@adornis/chemistry/elements/components/x-icon.js';
import '@adornis/chemistry/elements/components/x-loader.js';
import { XDialog } from '@adornis/dialog/x-dialog.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { ExamDay } from '../../db/examdays.js';

@customElement('ils-test-exam-dialog')
export class ILSTestExamDialog extends XDialog<Boolean> {
  static override get element_name() {
    return 'ils-test-exam-dialog';
  }

  override styles() {
    return [
      ...super.styles(),
      {
        ':host': {
          minWidth: '800px',
          minHeight: '600px',
        },
      },
    ];
  }

  @state() jobID!: string;

  @state() private _testExamProgress: string[] = [];

  @state() private _steps = [
    'Testers created',
    'ExamDay Created',
    'Candidates created',
    'Starting Order generation',
    'Candidates added to ExamDay',
    'ExamDay Scheduled',
  ];

  override connectedCallback(): void {
    super.connectedCallback();

    ExamDay.TestExamProgressSubscription(this.jobID)()?.subscribe(result => {
      this._testExamProgress = result;

      if (!this._steps.some(step => !this._testExamProgress.includes(step))) setTimeout(() => this.close(true), 500);
    });
  }

  override render() {
    return html`<x-flex space="sm" padding="md">
      <x-h2>Test-Examen wird erstellt...</x-h2>
      <x-grid columns="1fr max-content" space="sm">
        ${repeat<string>(
          this._testExamProgress,
          item => html`
            <x-flex center> <x-icon> done </x-icon> </x-flex>
            <x-flex center> <x-text> ${item} </x-text> </x-flex>
          `,
        )}
        ${repeat(this._steps, item => {
          if (!this._testExamProgress.includes(item))
            return html`
              <x-flex center> <x-loader style="height: 20px; width: 20px;"></x-loader> </x-flex>
              <x-flex center> <x-text ${css({ color: this.colors.neutral.shade(300) })}>${item}</x-text> </x-flex>
            `;
        })}
      </x-grid>
    </x-flex>`;
  }
}
